var render = function () {
  var _vm$resultCalculatePr, _vm$resultCalculatePr2, _vm$resultCalculatePr3, _vm$resultCalculatePr4, _vm$resultCalculatePr5, _vm$resultCalculatePr6, _vm$resultCalculatePr7;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.isEmpty(_vm.resultCalculatePrice) && (_vm$resultCalculatePr = _vm.resultCalculatePrice[0]) !== null && _vm$resultCalculatePr !== void 0 && _vm$resultCalculatePr.bargainFinder ? _c('BAlert', {
    staticClass: "px-50",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(" Quan trọng:"), _c('br'), _vm._v(" Có sự thay đổi về giá và hạng đặt chỗ. Vui lòng kiểm tra cẩn thận trước khi lưu. Hạng vé "), _c('span', {
    staticClass: "fw-700"
  }, [_vm._v("MÀU ĐỎ")]), _vm._v(" là hạng vé bị thay đổi! ")]) : _vm._e(), _vm.resultCalculatePrice ? _c('b-tabs', {
    attrs: {
      "nav-class": "bg-gray",
      "pills": ""
    }
  }, [_c('b-tab', {
    attrs: {
      "title": _vm.$t("flight['Pricing information']"),
      "title-item-class": "fw-700",
      "title-link-class": "px-75 hover-bg-light-warning",
      "active": ""
    }
  }, [_c('BTable', {
    staticClass: "mb-0 mt-25",
    attrs: {
      "small": "",
      "responsive": "",
      "hovered": "",
      "outlined": "",
      "items": _vm.resultCalculatePrice,
      "thead-tr-class": "text-nowrap",
      "tbody-tr-class": "text-nowrap text-right",
      "fields": ['passenger', 'quantity', 'net', 'tax', 'total']
    },
    scopedSlots: _vm._u([_vm._l(['passenger', 'quantity', 'net', 'tax', 'total'], function (column, indexColumn) {
      return {
        key: "head(".concat(column, ")"),
        fn: function fn(data) {
          return [_c('div', {
            key: indexColumn,
            class: "".concat(indexColumn === 0 ? 'text-center' : 'text-right')
          }, [_vm._v(" " + _vm._s(_vm.$t("reservation.".concat(data.column))) + " ")])];
        }
      };
    }), {
      key: "cell(passenger)",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_vm._v(" " + _vm._s(_vm.$t("flight.".concat(_vm.capitalize(item.passengerRequested.paxType)))) + " ")];
      }
    }, {
      key: "cell(quantity)",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_vm._v(" " + _vm._s(item.passengerRequested.quantity) + " ")];
      }
    }, {
      key: "cell(net)",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('span', {
          staticClass: "fw-600"
        }, [_vm._v(" " + _vm._s(_vm.formatCurrency(item.basePrice, item.currency)) + " ")])];
      }
    }, {
      key: "cell(tax)",
      fn: function fn(_ref4) {
        var item = _ref4.item;
        return [_c('span', {
          staticClass: "fw-600"
        }, [_vm._v(" " + _vm._s(_vm.formatCurrency(item.totalTaxes, item.currency)) + " ")])];
      }
    }, {
      key: "cell(total)",
      fn: function fn(_ref5) {
        var item = _ref5.item;
        return [_c('span', {
          staticClass: "fw-600 text-airline"
        }, [_vm._v(" " + _vm._s(_vm.formatCurrency(item.totalPrice, item.currency)) + " ")])];
      }
    }], null, true)
  }), _c('div', {
    staticClass: "text-right fw-700 mr-50"
  }, [_c('span', {
    staticClass: "mr-2"
  }, [_vm._v(" " + _vm._s(_vm.$t('flight.totalTickerFare')) + " ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" " + _vm._s(_vm.formatCurrency(_vm.resultCalculatePrice.reduce(function (acc, item) {
    return acc + item.totalPrice;
  }, 0), _vm.resultCalculatePrice[0].currency)) + " ")])])], 1), _c('b-tab', {
    attrs: {
      "title": _vm.$t('flight.priceInformation'),
      "title-item-class": "fw-700 border-left-secondary",
      "title-link-class": "px-75 hover-bg-light-warning"
    }
  }, [_c('ShortenBooking', {
    attrs: {
      "shorten-text": ((_vm$resultCalculatePr2 = _vm.resultCalculatePrice) === null || _vm$resultCalculatePr2 === void 0 ? void 0 : (_vm$resultCalculatePr3 = _vm$resultCalculatePr2[0]) === null || _vm$resultCalculatePr3 === void 0 ? void 0 : _vm$resultCalculatePr3.fareDetails) || undefined
    }
  })], 1), _c('b-tab', {
    attrs: {
      "title": "Điều kiện",
      "title-item-class": "fw-700 border-left-secondary",
      "title-link-class": "px-75 hover-bg-light-warning"
    }
  }, [_c('ShortenBooking', {
    attrs: {
      "shorten-text": ((_vm$resultCalculatePr4 = _vm.resultCalculatePrice) === null || _vm$resultCalculatePr4 === void 0 ? void 0 : (_vm$resultCalculatePr5 = _vm$resultCalculatePr4[0]) === null || _vm$resultCalculatePr5 === void 0 ? void 0 : _vm$resultCalculatePr5.fareRules) || undefined
    }
  })], 1), _c('b-tab', {
    attrs: {
      "title": "Hành lý",
      "title-item-class": "fw-700 border-left-secondary border-right-secondary",
      "title-link-class": "px-75 hover-bg-light-warning"
    }
  }, [_c('ShortenBooking', {
    attrs: {
      "shorten-text": ((_vm$resultCalculatePr6 = _vm.resultCalculatePrice) === null || _vm$resultCalculatePr6 === void 0 ? void 0 : (_vm$resultCalculatePr7 = _vm$resultCalculatePr6[0]) === null || _vm$resultCalculatePr7 === void 0 ? void 0 : _vm$resultCalculatePr7.bagInfo) || undefined
    }
  })], 1)], 1) : _c('div', {
    staticClass: "text-warning font-italic mx-1"
  }, [_vm._v(" Chưa tính giá ")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }